/**
 * B-7233: shown when a line edit was refused because the estimate changed after
 * this page loaded it (for example a chat approval). The only safe next step is
 * to reload, so the notice offers exactly that.
 */
import { useEffect, useState } from 'react';
import { ESTIMATE_CHANGED_EVENT, ESTIMATE_CHANGED_MESSAGE } from '../../lib/estimateChanged';

export default function EstimateChangedNotice({
  onReload = () => window.location.reload(),
}: {
  onReload?: () => void;
}) {
  const [stale, setStale] = useState(false);

  useEffect(() => {
    const show = () => setStale(true);
    window.addEventListener(ESTIMATE_CHANGED_EVENT, show);
    return () => window.removeEventListener(ESTIMATE_CHANGED_EVENT, show);
  }, []);

  if (!stale) return null;
  return (
    <div
      role="alert"
      data-testid="estimate-changed-notice"
      className="mb-4 flex items-center justify-between gap-3 rounded-[var(--r-sm)] border border-[var(--accent-line)] bg-[var(--bg-inset)] px-3 py-2.5 text-[13px] text-[var(--tx-hi)]"
    >
      <span>{ESTIMATE_CHANGED_MESSAGE}</span>
      <button
        type="button"
        onClick={onReload}
        className="h-[28px] px-3 rounded-[var(--r-sm)] text-[12px] font-semibold bg-[var(--accent)] text-[var(--bg-1)]"
      >
        Reload
      </button>
    </div>
  );
}
